module.exports = __webpack_public_path__ + "img/admin_adv_01.1a5e45bb.png";